import * as React from "react";
import MaterialTable from "@material-table/core";
import {
    Fab, Paper, Fade, Tooltip,
    Box,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Button,
    FormControl,
    Grid,
    TextField
} from "@mui/material";
import api from "../../services/api";
import { tiposCargas, tiposServicos, getLabelEnquadramento } from "../../static";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import { useStoreState, useStoreActions } from "easy-peasy";
import { materialTableLocalization } from "../../config";
import { Rule } from "@mui/icons-material";
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
//import FornecedorDialogoTomada from "./FornecedorDialogoTomada";

import DialogoAcompanhaOrcamentosFaseTwo from "../../components/TomadaPreco/DialogoAcompanhaOrcamentosFaseTwo";

const FornecedorPedidoOrcamento = (fornecedorId) => {
    let user = useStoreState((state) => state.auth.user);
    let startLoading = useStoreActions((actions) => actions.nav.startLoading);
    let stopLoading = useStoreActions((actions) => actions.nav.stopLoading);

    const [openDlgViewFaseTwo, setOpenDlgViewFaseTwo] = React.useState(false);
    const [rowDataFaseTwo, setRowDataFaseTwo] = React.useState([]);
    const [dados, setDados] = React.useState();

    const tableRef = React.createRef();
    const [columns, setColumns] = React.useState([]);
    // const [openDlgCadOrcamento, setOpenDlgCadOrcamento] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [fields, setFields] = React.useState([{
        // discrFabr: '', tipoFiname: 'Com codigo FINAME', codFiname: '',
        // hasCodPotencializee: 'Sem Código Potencializee', codpotencializee: '', 
        tipoLampada: 'led', formatoLampada: 'tubular',
        potencia: '20', liminosidade: '2500',
        // fatorPotencia: '0,92', eficienciaLuminosa: '90', temperaturaCor: '4000',
        // tempoGarantia: '3', possuiProcel: 'Sim', classificacaoImetro: 'A',
        // vidaUtil: '25000', quantidade: '20', valorunitario: '10', valortotal: '200', valorprevistointalacao: '100',
        // valorprevistodescarte: '100', total: '400'
    }]);


    const loadOrcamentos = async (query) => {
        startLoading();
        try {
            let getOrcamentosAux = (
                await api.http.get("/fornecedores/orcamentosprocessos/",
                    {
                        params: {
                            page: query.page + 1,
                            pageSize: query.pageSize,
                            carga: 'orcamento',
                            orderBy: query.orderBy ? query.orderBy.field : undefined,
                            orderDirection: query.orderDirection
                                ? query.orderDirection
                                : undefined,
                            fornecedorId: fornecedorId?.fornecedorId,
                        },
                    }
                )
            )

            stopLoading();
            return {
                data: getOrcamentosAux.data.data,
                page: getOrcamentosAux.data.meta.current_page - 1,
                totalCount: getOrcamentosAux.data.meta.total,
            };
        } catch (error) {
            stopLoading({
                message: error.toString(),
                severity: "error",
            });
            return {
                data: [],
                page: 0,
                totalCount: 0,
            };
        }
    };

    const mapTipoCargaToLabel = (tipoCarga) => {
        const cargaEncontrada = tiposCargas.find((item) => item.id === tipoCarga);
        if (cargaEncontrada) {
          return cargaEncontrada.label;
        }
      
        const servicoEncontrado = tiposServicos.find((item) => item.id === tipoCarga);
        if (servicoEncontrado) {
          return servicoEncontrado.label;
        }
      
        return tipoCarga;
    };

    React.useEffect(() => {
        setColumns([
        {
            field: 'id',
            title: 'Nr. Pedido',
            align: 'left',
        },
        {
            field: 'tipoCarga',       
            title: 'Tecnologia/Serviço',
            align: 'left',
            render: rowData => mapTipoCargaToLabel(rowData.tipoCarga),
        },
        {
            field: 'enquadramento',
            title: 'Enquadramento',
            align: 'left',
            render: rowData => getLabelEnquadramento(rowData.enquadramento),
        },
        {
            field: 'estagio',
            title: 'Estágio',
            align: 'left',
        },
        {
            field: 'auditorNome',
            title: 'Especialista',
            align: 'left',
        },
        {
            field: 'localizacao',
            title: 'Cidade/UF',
            align: 'center',
        },
        {
            field: 'updatedAt',
            title: 'Última atualização',
            align: 'center',
            render: rowData => new Date(rowData.updatedAt).toLocaleString(),
          }
        ])
    }, [])

    const onRowClick = async (event, rowData) => {
        startLoading();
    
        try {
            let getOrcamentos = await api.http.get("/fornecedores/orcamentos/processo/tomada/itens/" + rowData.id);
            
            const rowDataWithExtras = {
                ...rowData,
                extras: {
                    cidade: rowData.cidade,
                    estado: rowData.estado,
                },
            };
    
            setDados(getOrcamentos);
    
            setRowDataFaseTwo(rowDataWithExtras);
            setOpenDlgViewFaseTwo(true);
            stopLoading();
        } catch (error) {
            stopLoading({
                message: error.toString(),
                severity: "error",
            });
        }
    
        setOpen(true);
    };

    const onCloseDlgFaseTwo = () => {
        setOpenDlgViewFaseTwo(false);
        if (tableRef.current) {
            tableRef.current.onQueryChange();
        }
    };

    const handleClose = () => setOpen(false);

    return (
        <Paper
        >
            <DialogoAcompanhaOrcamentosFaseTwo open={openDlgViewFaseTwo} onClose={onCloseDlgFaseTwo} orcamento={rowDataFaseTwo} isFornecedor itens={dados} />
            <MaterialTable
                columns={columns}
                data={loadOrcamentos}
                title="2ª Fase Tomada de Preços"
                onRowClick={onRowClick}
                localization={materialTableLocalization}
                tableRef={tableRef}

            />

        </Paper>
    );
};

export default FornecedorPedidoOrcamento;